import './WhyUs.css';
import WhyUsBanner from './WhyUs/WhyUsBanner';
import LocalBackground from './WhyUs/LocalBackground';
import Recommendation from './WhyUs/Recommendation';
import DesignForFamilies from './WhyUs/DesignForFamilies';
import ProfessionalInstall from './WhyUs/ProfessionalInstall';
import RealLocalSupport from './WhyUs/RealLocalSupport';
import WorkManufacture from './WhyUs/WorkManufacture';
import LongTermThinking from './WhyUs/LongTermThinking';
import CustomerReviews from './WhyUs/CustomerReviews';
import ReadyToExplore from './WhyUs/ReadyToExplore';
export default function WhyUs() {
  return (
    <div className="why-us-page">
      <WhyUsBanner />
      <div className="page-container">
        <LocalBackground />
        <Recommendation />
        {/* <DesignForFamilies /> */}
        {/* <ProfessionalInstall /> */}
        {/* <RealLocalSupport /> */}
        {/* <WorkManufacture /> */}
        {/* <LongTermThinking /> */}
        <CustomerReviews />
        <ReadyToExplore />
      </div>
    </div>
  );

}